<template lang="pug">
CardMinimal(title="Swish", :tooltip="$t('settings.swish_description')", tooltipClass="bottom-right")
  template(slot="header")
    .p-a-4
      .swish
        .swish-logo
          img(src="@/assets/swish-logo.svg")
        .swish-description
          p {{ $t('settings.swish_extended_description') }}
  .bank-accounts(v-if="bankAccounts && bankAccounts.length > 0")
    ExpandableListItem(v-for="account in bankAccounts", :key="account.bank_account_id")
      .p-a-4.d-f.ai-c
        p {{ account.bank_name }} ••• {{ account.last_4 }}
      template(slot="dots")
        ul
          li.red(@click="removeAccount(account.id)")
            i.mdi.mdi-trash-can-outline
            | {{ $t('products.remove') }}
  .bank-accounts(v-else-if="bankAccounts && bankAccounts.length === 0")
    .p-a-4: p.ta-c {{ $t('settings.bank_no_accounts') }}
  .bank-accounts.d-f.ai-c.jc-c.fd-c.ta-c(v-else)
    i.mdi.mdi-loading.mdi-spin
  .p-a-4.d-f.ai-c.jc-c(slot="footerButton", @click="addBankAccount = true")
    i.mdi.mdi-plus-circle
    span {{ $t('settings.add_bank_account') }} for Swish
  portal(to="modals")
    Modal(:show="addBankAccount", :stuck="createState !== ''" @close="cancelAddBankAccount()" title="Add bank account for Swish").auto-height
      .p-a-4
        p.m-b-1 {{ $t('settings.bank_accountnumber').toUpperCase() }}
        FormInput(type="text", v-model="newAccount.account_number", id="account-number", :outline="true").m-b-2
        p.m-b-1 {{ $t('settings.bank_account_type').toUpperCase() }}
        FormDropdown(:items="accountTypes", :maxHeight="150" placeholder="Välj", :value="newAccount.account_type", @input="newAccount.account_type = $event.value").medium
      template(v-slot:footer)
        .d-f.f-w
          Button.m-r-4(@click="addBankValid ? createBankAccount() : null", style="white-space: nowrap", :disabled="!addBankValid", :class="`${addBankValid ? 'very-blue' : 'very-blue-light'}`")
            template(v-if="createState === ''") {{ $t('settings.add_bank_account') }}
            template(v-else-if="createState === 'creating'") {{ $t('settings.adding_bank_account') }}
            template(v-else-if="createState === 'created'") {{ $t('settings.bank_account_added') }}
          Button.ml-a.outline(@click="cancelAddBankAccount()") Cancel
</template>

<script>

import ExpandableListItem from '@/components/Lists/ExpandableListItem.vue';

export default {
  components: {
    ExpandableListItem,
  },
  computed: {
    /**
     * Return id of account if assumed
     * @returns {Number}
     */
    assumedAccount() {
      return parseInt(this.$store.getters['User/assumed'], 10);
    },
    /**
     * Return list of bankaccount
     * @returns {?Array}
     */
    bankAccounts() {
      return this.$store.getters['AccountManager/swishBankAccounts'];
    },
    accountTypes() {
      const { account_type } = this.newAccount;
      return [
        { value: 'bank', string: 'Bankkonto', selected: account_type === 'bank' },
        { value: 'bg', string: 'Bankgiro', selected: account_type === 'bg' },
        { value: 'pg', string: 'Plusgiro', selected: account_type === 'pg' },
      ];
    },
    addBankValid() {
      const { account_type, account_number } = this.newAccount;
      return account_type !== '' && account_number !== '';
    },
  },
  methods: {
    /**
     * Get bank accounts from interwebs
     */
    getBankAccounts() {
      this.$store.dispatch('AccountManager/getSwishBankAccounts');
    },
    /**
     * Cancel creating a new account, reseting state
     */
    cancelAddBankAccount() {
      this.addBankAccount = false;
      this.createState = '';
      this.newAccount = {
        account_type: '',
        account_number: '',
      };
    },
    /**
     * Create a new bank account
     */
    async createBankAccount() {
      this.createState = 'creating';

      const { account_number, account_type } = this.newAccount;

      const result = await this.$store.dispatch('AccountManager/addSwishBankAccount', {
        account_type,
        account_number,
      });

      if (!result) {
        this.createState = '';
        swal({ title: 'An error occured', text: 'For some reason we could not save this bankaccount information right now', icon: 'error' });
        return;
      }

      this.createState = 'created';
      setTimeout(() => {
        this.cancelAddBankAccount();
      }, 2000);

      this.getBankAccounts();
    },
    /**
     * Remove a bank account
     * @param {String} id
     */
    async removeAccount(id) {
      const result = await this.$store.dispatch('AccountManager/removeSwishBankAccount', id);
      if (!result) {
        swal({ title: 'An error occured', text: 'For some reason we could not save this bankaccount information right now', icon: 'error' });
        return;
      }
      this.getBankAccounts();
    },
  },
  data() {
    return {
      addBankAccount: false,
      createState: '',
      newAccount: {
        account_type: '',
        account_number: '',
      },
    };
  },
  watch: {
    /**
     * Watching for assumed. If changed, reload users.
     */
    assumedAccount() {
      this.getBankAccounts();
    },
  },
  mounted() {
    this.getBankAccounts();
  },
};
</script>

<style lang="scss" scoped>
.swish {
  align-items: center;
  display: flex;

  .swish-logo {
    min-width: 120px;
    margin-right: 10px;
    img {
      height: 70px;
      margin: 0 auto;
    }
  }
}
</style>
